import React, { useState } from 'react';
import leftarrow from '../../../../../../assets/arrow-left (2).svg';
import rightarrow from '../../../../../../assets/arrow-right (3).svg';
import "./Pag.css";

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ currentPage, totalPages, totalItems, onPageChange }: PaginationProps) => {
  const [goToPage, setGoToPage] = useState('');
  const handlePageChange = (page: number) => {
    if (page !== currentPage && page > 0 && page <= totalPages) {
      onPageChange(page)
        ;
    }
  };

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  const handleInputChange = (e: any) => {
    setGoToPage(e.target.value);
  };
  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      const pageNumber = parseInt(goToPage);
      if (!isNaN(pageNumber) && pageNumber !== currentPage && pageNumber > 0 && pageNumber <= totalPages) {
        onPageChange(pageNumber);
        setGoToPage('');
      }
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    // Always show the first page number
    pageNumbers.push(
      <div
        key={1}
        className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
        onClick={() => handlePageChange(1)}
      >
        1
      </div>
    );

    // Logic to determine placement of ellipsis and other page numbers
    if (totalPages > 1) {
      if (totalPages <= 6) {
        // Show all page numbers directly
        for (let i = 2; i <= totalPages; i++) {
          pageNumbers.push(
            <div
              key={i}
              className={`pagination-number ${currentPage === i ? 'active' : ''}`}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </div>
          );
        }
      } else {
 
        if (currentPage <= 3) {

          for (let i = 2; i <= 4; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (totalPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPages}
              className={`pagination-number ${currentPage === totalPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </div>
          );
        } else if (currentPage >= totalPages - 2) {
          // Show the last 4 pages and ellipsis if more than 4 pages
          pageNumbers.push(
            <div
              key={1}
              className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (totalPages > 5) {
            pageNumbers.push(
              <div key="ellipsis" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = totalPages - 3; i <= totalPages; i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
        } else {
          // Show pages around the current page with ellipsis on both ends
          pageNumbers.push(
            <div
              key={1}
              className={`pagination-number ${currentPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}
            >
              2
            </div>
          );
          if (currentPage > 4) {
            pageNumbers.push(
              <div key="ellipsis-start" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          for (let i = Math.max(currentPage - 1, 2); i <= Math.min(currentPage + 1, totalPages - 1); i++) {
            pageNumbers.push(
              <div
                key={i}
                className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                onClick={() => handlePageChange(i)}
              >
                {i}
              </div>
            );
          }
          if (currentPage < totalPages - 3) {
            pageNumbers.push(
              <div key="ellipsis-end" className="pagination-number ellipsis">
                ..
              </div>
            );
          }
          pageNumbers.push(
            <div
              key={totalPages}
              className={`pagination-number ${currentPage === totalPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </div>
          );
        }
      }
    }
    return pageNumbers;
  };
  const renderPaginationInfo = () => {
    const startItem = (currentPage - 1) + 1;
    const endItem = Math.min(totalPages);

    return `${startItem}-${endItem} of ${totalItems}`;
  };


  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "6px 14px",
      borderRadius: "6px",
      background: "#F4F8FE"
    }} className="pagination-container">
      <div className="pagination-info">
        {renderPaginationInfo()}
      </div>
      <div className='middle-container'>
        <div className="pagination-controls">
          <div
            style={{ flexDirection: "row" }}
            className={`pagination-control ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={handlePreviousClick}
          >
            <img className='left-arrow' src={leftarrow} alt="leftarrow" />
          </div>
        </div>
        <div className="pagination-numbers">
          {renderPageNumbers()}
        </div>
        <div className="pagination-controls">
          <div
            style={{ flexDirection: "row" }}
            className={`pagination-control ${currentPage === totalPages ? 'disabled' : ''}`}
            onClick={handleNextClick}
          >
            <img className='right-arrow' src={rightarrow} alt="rightarrow" />
          </div>
        </div>
      </div>
    </div>

  );
};

export default Pagination;
